import { ToastService } from '@utils/toast.service';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { UserService } from '@services/user.service';
import { SessionService } from '@utils/session.service';
import { UtilsService } from '@utils/utils.service';
import { CatalogService } from '@services/catalog.service';

@Component({
  selector: 'app-disable-multiple-modules',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ButtonModule, MultiSelectModule],
  templateUrl: './disable-multiple-modules.component.html',
  styleUrl: './disable-multiple-modules.component.scss',
})
export class DisableMultipleModulesComponent {
  private formBuilder = inject(FormBuilder);
  private userService = inject(UserService);
  private utils = inject(UtilsService);
  private sessionService = inject(SessionService);
  private toastService = inject(ToastService);
  private catalogService = inject(CatalogService);

  public listUsers: any[] = [];
  public permissions: any[] = [];

  public form = this.formBuilder.group({
    users: [null, Validators.required],
    modules: [null, Validators.required],
  });

  public ngOnInit() {
    let userId = this.sessionService.getUser()?.userId;

    this.userService.getUsersOfUser(Number(userId)).then((response: any) => {
      this.listUsers = response.childrens.map((user: any) => ({ label: user.nickname, value: user.userId }));

      this.listUsers = this.utils.orderArrayBy(this.listUsers, 'label');
    });

    this.catalogService.getPermissionsList().then((response) => (this.permissions = response));
  }

  removeModuleUser() {
    if (this.form.invalid) {
      this.toastService.error('Por favor, completa todos los campos requeridos.');
      return;
    }

    let users = this.form.value.users;
    let modules = this.form.value.modules;

    this.userService
      .disableModuleUser({ users, modules })
      .then((response: any) => {
        this.toastService.success('Módulos deshabilitados correctamente.');
        this.form.reset();
      })
      .catch((error: any) => {
        this.toastService.error(error.message || 'Ocurrió un error al desactivar el módulo.');
      });
  }
}
